import { Component } from '../core/component';

export class UserIsTabbing extends Component {
    constructor() {
        super();
        this.selector = 'main';
    }

    init() {
        const html = document.getElementsByTagName('html')[0];

        window.addEventListener('keydown', (e) => {
            if (e.keyCode === 9) {
                html.classList.add('user-is-tabbing');
            }
        });

        window.addEventListener('mousedown', () => {
            html.classList.remove('user-is-tabbing');
        });
    }
}
